<template>
  <div class="OrderSummary-root">
    <info-box bordered :column="3">
      <template v-if="orderDetail" slot="mainContent">
        <a-descriptions-item label="订单状态">
          <status-tag
            :type="orderSummary.status === UnifyOrderStatusKey.EXP_CAL_STATUS || orderSummary.status === UnifyOrderStatusKey.FAIL_CREDIT ? 'err' : ''"
            :text="filterText(orderSummary.status)"></status-tag>
          <span v-track-click="{ trackName: '纯运输-查看明细（U）' }" class="viewDetails" @click="checkLogs">查看明细</span>
        </a-descriptions-item>
        <a-descriptions-item label="所选线路">
          <p v-if="orderSummary.isLine">
            {{ orderSummary.lineRemark }}
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="订单号">
          {{ orderSummary.odrNo }}
        </a-descriptions-item>
        <a-descriptions-item v-if="sensitiveFields.includes('use_car_ask')" label="用车要求">
          {{ orderSummary.orderTypeTxt }}
        </a-descriptions-item>
        <a-descriptions-item label="外部订单号">
          {{ orderSummary.crmNumber }}
        </a-descriptions-item>
        <a-descriptions-item label="车型">
          {{ orderSummary.carTypeName }}
        </a-descriptions-item>
        <a-descriptions-item label="下单时间">
          {{ orderSummary.orderTime }}
        </a-descriptions-item>
        <a-descriptions-item label="订单来源">
          {{ orderSummary.odrChannel }}
        </a-descriptions-item>
        <!-- <a-descriptions-item label="是否提货">
                    {{orderSummary.needPickUp}}
                </a-descriptions-item>
                <a-descriptions-item label="是否配送">
                    {{orderSummary.needDelivery}}
                </a-descriptions-item> -->
        <!-- <a-descriptions-item v-if="!orderSummary.productCode" label="线路标识">
                    {{orderSummary.lineId ? orderSummary.lineRemark : ''}}
                </a-descriptions-item> -->
        <a-descriptions-item label="下单人">
          {{ orderSummary.createUserName }}
        </a-descriptions-item>
        <a-descriptions-item v-if="sensitiveFields.includes('providers')" label="服务商">
          {{ orderSummary.carrierTenantName }}
        </a-descriptions-item>
        <a-descriptions-item v-if="sensitiveFields.includes('payment_method')" label="付款方式">
          {{ orderSummary.settlementMethod }}
        </a-descriptions-item>
        <a-descriptions-item v-if="orderSummary.orderLabel" label="销售渠道">
          {{ orderSummary.orderLabel }}
        </a-descriptions-item>
        <a-descriptions-item label="预估里程" :span="2">
          {{ orderSummary.mileageKm ? `${orderSummary.mileageKm}km` : '' }}
          <span
            v-if="(orderSummary.status !== UnifyOrderStatusKey.SUBMITTED || orderSummary.status !== UnifyOrderStatusKey.DRAFT) && orderDetail.calculateMileage"
            class="tipsStyle">
            <a-icon type="info-circle" />
            该里程通过起始地与目的地计算得到
          </span>
        </a-descriptions-item>
        <a-descriptions-item v-if="sensitiveFields.includes('project')" label="运营项目">
          {{ orderSummary.projectName }}
        </a-descriptions-item>
        <a-descriptions-item v-if="sensitiveFields.includes('project_leader')" label="项目负责人信息">
          <a-tooltip>
            <template #title>
              <p v-for="(item, index) in orderSummary.mainUser" :key="index">
                {{ item }}
              </p>
            </template>
            <div class="ellipsis main-user">
              {{ orderSummary.mainUser.join(',') }}
            </div>
          </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item label="备注">
          {{ orderSummary.remark }}
        </a-descriptions-item>
      </template>
    </info-box>
    <status-modal ref="statusModal" />
  </div>
</template>

<script>
import moment from 'moment'
import StatusTag from '@/components/tag/StatusTag.vue'
import InfoBox from './InfoBox.vue'
import { orderTypeMap, OdrChannelMap, UnifyOrderStatus, OrderStatusCode, minGroupSize, ORDERSTATUS, UnifyOrderStatusKey } from '../../constant.js'
// import { getContract } from '../../api.js'
import StatusModal from '../../components/StatusModal.vue'

const payment = {
  FREIGHT_COLLECT: '到付现结',
  FREIGHT_PREPAID: '寄付现结',
}

export default {
  name: 'OrderSummary',
  components: {
    InfoBox,
    StatusTag,
    StatusModal,
  },
  props: {
    orderDetail: {
      type: Object,
      default: () => (null)
    },
    sensitiveFields: {
      type: Array,
      default: () => ([]),
    }
  },
  data () {
    return {
      contractList: [],
      UnifyOrderStatus,
      OrderStatusCode,
      groupSize: 0,
      minGroupSize,
      ORDERSTATUS,
      UnifyOrderStatusKey,
      payment,
    }
  },
  computed: {
    orderSummary () {
      const { orderDetail } = this
      const mainUser = []
      const { unifyProjectGroups = [] } = orderDetail
      unifyProjectGroups.forEach(item => {
        mainUser.push(`${item.userName || ''}${item.userPhone || '' ? `(${item.userPhone || ''})` : ''}`)
      })
      return {
        ...orderDetail,
        odrNo: orderDetail.unifyOrderNo,
        orderTypeTxt: orderTypeMap[orderDetail.orderType],
        crmNumber: orderDetail.crmNumber,
        orderTime: moment(orderDetail.createTime).format('YYYY-MM-DD HH:mm:ss'),
        odrChannel: OdrChannelMap[orderDetail.odrChannel],
        needShelves: orderDetail.ext?.needShelves ? '是' : '否',
        needHandling: orderDetail.ext?.needHandling ? '是' : '否',
        needPickUp: orderDetail.needPickUp ? '是' : '否',
        needDelivery: orderDetail.needDelivery ? '是' : '否',
        productCode: !!orderDetail.ext?.productCode,
        remark: orderDetail.remark,
        carTypeName: orderDetail.carTypeName,
        orderType: orderDetail.orderType,
        lineId: orderDetail.lineId,
        lineRemark: orderDetail.lineName,
        isLine: orderDetail.isLine,
        contractCode: orderDetail.contractCode,
        code: orderDetail.productCode,
        status: orderDetail.status,
        mileageKm: orderDetail.mileageKm,
        createUserName: orderDetail.createUserName,
        carrierTenantName: orderDetail.ext?.demoData ? '运荔枝演示' : orderDetail.carrierTenantName,
        settlementMethod: payment[orderDetail.settlementMethod],
        orderLabel: orderDetail.orderLabel,
        mainUser,
      }
    },
  },
  async created () {
    // const {creditCode,customerCode}=this.$store.state.user
    // const data={
    //   status: 'ENABLED',
    //   needAllContracts: true,
    // }
    // data.cargoOwnerCode=creditCode?this.orderDetail.tenantId:customerCode
    // this.contractList = await getContract(data)
  },
  mounted () {
  },
  methods: {
    filterText (data) {
      return `${UnifyOrderStatus[data] || ''}`
    },
    async checkLogs () {
      const { unifyOrderNo } = this.orderDetail
      this.$refs.statusModal.show(unifyOrderNo)
    },
    filterContract (value, code) {
      if (!value || !code) return ''
      let test = ''
      this.contractList.forEach((e) => {
        if (e.contractCode === value) {
          test += e.contractName
          e.contractTermInfo.forEach((n) => {
            if (code === n.code) {
              test += `-${n.name}`
            }
          })
        }
      })
      return test
    },
  },
}
</script>

<style lang="less" scoped>
.OrderSummary-root {
  background-color: #fff;
  border-radius: 6px;
}

.info-panel {
  margin-top: 0 !important;
}

.tipsStyle {
  font-size: 12px;
  color: #A9ABAE;
  margin-left: 16px;
}

.lineStyle {
  width: calc(100% - 60px);
  height: 1px;
  margin-left: 30px;
  background-color: #E8E8E8;
}

.InfoBox-root {
  padding-bottom: 32px;
}

.orderLine {
  padding: 20px 30px 4px;
}

.viewDetails {
  font-size: 12px;
  line-height: 24px;
  color: #171717;
  margin-left: 8px;
  color: #06B880;
  cursor: pointer;
}

.lineText {
  display: inline-block;
  background: #ED9849;
  border-radius: 4px;
  color: #fff;
  padding: 0 9px;
}

.main-user {
  max-width: 240px;
}</style>